import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, MessageCircle, Sparkles, BadgeCheck } from "lucide-react";
import api, { apiError } from "../../lib/api";

export default function InquiriesTab() {
  const [items, setItems] = useState([]);
  const [sponsored, setSponsored] = useState(true);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/admin/inquiries", { params: { sponsored } }).then((r) => setItems(r.data)).catch((e) => toast.error(apiError(e)));
  }, [sponsored]);

  const download = async () => {
    try {
      const res = await api.get("/admin/export/inquiries", { params: { sponsored }, responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a"); a.href = url; a.download = "inquiries.xlsx"; a.click(); URL.revokeObjectURL(url);
    } catch (err) { toast.error(apiError(err)); }
  };

  const list = items.filter((i) => !q || `${i.name} ${i.phone} ${i.institution_name} ${i.message}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="mt-8">
      <div className="flex flex-wrap items-center gap-3">
        <div className="nb-flat inline-flex p-1" style={{ borderRadius: 9999 }}>
          <button data-testid="inq-filter-sponsored" onClick={() => setSponsored(true)} className="px-4 py-1.5 rounded-full text-sm font-bold" style={sponsored ? { background: "#171B33", color: "#fff" } : {}}>Sponsored only</button>
          <button data-testid="inq-filter-all" onClick={() => setSponsored(false)} className="px-4 py-1.5 rounded-full text-sm font-bold" style={!sponsored ? { background: "#171B33", color: "#fff" } : {}}>All institutes</button>
        </div>
        <input data-testid="inq-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name, phone, institute…" className="nb-input flex-1 min-w-[200px]" style={{ maxWidth: 360 }} />
        <button data-testid="inq-export-btn" onClick={download} className="nb-btn nb-btn-sm ml-auto"><Download className="w-4 h-4" /> Export Excel</button>
      </div>
      <p className="text-xs text-slate-500 mt-3">{list.length} inquiries · messages students sent to {sponsored ? "Featured / Verified" : "all"} institutes</p>
      <div className="mt-4 space-y-3">
        {list.length === 0 && <p className="text-sm text-slate-500 nb-flat p-8 text-center border-dashed">No inquiries yet.</p>}
        {list.map((i) => (
          <div key={i.id} data-testid={`inq-row-${i.id}`} className="nb p-4 flex flex-col sm:flex-row sm:items-start gap-3">
            <div className="flex-1 min-w-0">
              <p className="font-display font-extrabold flex items-center gap-2 flex-wrap">{i.institution_name}
                {i.badge === "featured" && <span className="nb-badge" style={{ background: "#FCD34D", padding: "1px 8px", fontSize: 10 }}><Sparkles className="w-3 h-3" /> Featured</span>}
                {i.badge === "verified" && <span className="nb-badge" style={{ background: "#93C5FD", padding: "1px 8px", fontSize: 10 }}><BadgeCheck className="w-3 h-3" /> Verified</span>}
                <span className="text-xs font-sans font-normal text-slate-400 capitalize">{i.institution_type}</span>
              </p>
              <p className="text-sm mt-1"><span className="font-bold">{i.name}</span> · {i.phone}</p>
              {i.message && <p className="text-sm text-slate-600 mt-1">{i.message}</p>}
              <p className="text-[11px] text-slate-400 mt-1">{new Date(i.created_at).toLocaleString()}</p>
            </div>
            <a href={`https://wa.me/${(i.phone || "").replace(/\D/g, "")}`} target="_blank" rel="noreferrer" data-testid={`inq-wa-${i.id}`} className="nb-btn nb-btn-sm shrink-0"><MessageCircle className="w-4 h-4" /> WhatsApp</a>
          </div>
        ))}
      </div>
    </div>
  );
}
